import React from "react";
import "./AboutSection.css";

function AboutSection() {
  return (
    <section className="container py-5">
      <h2 className="text-center mb-4">WELCOME TO RESEARCH DISCOURSE</h2>
      <p className="text-center">
        Research Discourse: An International Peer-reviewed Refereed Research
        Journal, ISSN 2277-2014(Print) NSL/ISSN/INF/2011, Dated 04/01/2012 is a
        Quarterly (March,June,September, December & Supplement Issue),
        open-access (OA) journal . Published by- South Asia Research &
        Development Institute, B. 28/70, Manas Mandir, Durgakund ,Varanasi,
        U.P., INDIA.
      </p>
      <div className="d-flex justify-content-center">
        <hr className="custom-line" />
      </div>
      <div className="row text-center mt-4">
        <marquee className="marquee">
          EX.UGC APPROVED JOURNAL NO.63580. Indexed By – IIJIF , I2OR, SJIF.
          I2OR Impact Factor- 7.565 for the year 2024 Coming soon issue
          January-March 2024
        </marquee>
      </div>

      <div className="row align-items-center mt-5">
        <div className="col-md-6 text-center image-container">
          <span></span>
          <img
            src="http://researchdiscourse.org/wp-content/uploads/2021/05/WhatsApp-Image-2021-05-13-at-10.11.53-AM-e1654337675120.jpeg"
            alt="Certificate"
            className="img-fluid"
          />
        </div>
        <div className="col-md-6">
          <h3>
            <strong>Overview</strong>
          </h3>
          <p className="overview">
            The major aim is to rapidly report the most recent developments in
            research by academicians and students. We accept papers on aspects
            related to Arts, Social, Law, Management, and Commerce, among
            others. We also encourage papers that cover all other areas of
            knowledge as well as basic research.
          </p>
          <div className="accordion" id="researchAccordion">
            <div className="accordion-item mt-3 mb-2">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#mission"
                  aria-expanded="true"
                  aria-controls="mission"
                >
                  Our Mission
                </button>
              </h2>
              <div
                id="mission"
                className="accordion-collapse collapse show"
                data-bs-parent="#researchAccordion"
              >
                <div className="accordion-body">
                  The biggest advantage of the OA model is that it provides
                  free, full-text articles in PDF and other formats for experts
                  and the public without registration.The open access model has
                  been proven to be a true approach that may achieve the
                  ultimate goal of the journals, i.e. the maximization of the
                  value to the readers, authors, libraries, colleges,
                  universities and society.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#vision"
                  aria-expanded="false"
                  aria-controls="vision"
                >
                  Our Vision
                </button>
              </h2>
              <div
                id="vision"
                className="accordion-collapse collapse"
                data-bs-parent="#researchAccordion"
              >
                <div className="accordion-body">
                  The role of academic journals is to exhibit the scientific
                  levels of a country, a university, a center, a department, and
                  even a scientist, and build an important bridge for
                  communication between researchers and the public.
                </div>
                <div className="accordion-body last-para">
                  The maximization of personal benefits refers to the pursuit of
                  the maximum personal benefits in a well-considered optimal
                  manner without violation of the laws, ethical rules and the
                  benefits of others.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { AboutSection };
